{
  "defaultLocale": "en",
  "locales": ["en", "en-CA", "fr-CA", "es", "pt-BR"],
  "files": {
    "gt": {
      "output": "public/i18n/[locale].json"
    }
  }
}
